import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import { Button, FooterActionBar } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import { getMessageKey } from '../../../utils/utils';
import { getBulkActionFooterBtns } from '../constant';
import { BULK_ACTION_COMMON } from '../mockData';

import { COMMENT_MINIMUM_LENGTH } from './constant';

function BulkActionCommonFooter({
  handleCommonAction,
  bulkActionCommonAction,
  handleCloseBulkActionCommon,
}) {
  const intl = useIntl();
  const { messages } = useSelector((state) => state?.user);
  const {
    core: { campaignType },
    lineActions: { reassignConfigMap },
  } = useSelector((state) => state?.certifications?.details);

  const submitBtnKind =
    bulkActionCommonAction?.isSubmitting ||
    (bulkActionCommonAction?.comment?.replace(/^\s+|\s+$/gm, '')?.length >
      COMMENT_MINIMUM_LENGTH &&
      bulkActionCommonAction?.hasAgreed)
      ? 'filled'
      : 'outlined';

  const getActionButtonText = (key) => {
    switch (key) {
      case getBulkActionFooterBtns(campaignType, reassignConfigMap).WORKS_FOR_ME
        .id:
        return (
          messages['Approve.all.ATTESTATIONS'] ||
          localize(intl, getMessageKey('Approve.all'))
        );
      case getBulkActionFooterBtns(campaignType, reassignConfigMap)
        .BELONGS_TO_ME.id:
        return (
          messages['Approve.all.ATTESTATIONS'] ||
          localize(intl, getMessageKey('Approve.all'))
        );
      case getBulkActionFooterBtns(campaignType, reassignConfigMap).APPROVE.id:
        return (
          messages['Approve.all.ATTESTATIONS'] ||
          localize(intl, getMessageKey('Approve.all'))
        );
      case getBulkActionFooterBtns(campaignType, reassignConfigMap).TERMINATE
        .id:
        return (
          messages['Terminate.ATTESTATIONS'] ||
          localize(intl, getMessageKey('Terminate'))
        );
      case getBulkActionFooterBtns(campaignType, reassignConfigMap).DECOMMISSION
        .id:
        return (
          messages['CERTS_BULK_DECOMMISSION.all.ATTESTATIONS'] ||
          localize(intl, getMessageKey('CERTS_BULK_DECOMMISSION.all'))
        );

      case getBulkActionFooterBtns(campaignType, reassignConfigMap).REJECT.id:
        return (
          messages['Reject.all.ATTESTATIONS'] ||
          localize(intl, getMessageKey('Reject.all'))
        );
      default:
        return (
          messages.CERTS_BULK_UNKNOWN_ACTION ||
          localize(intl, getMessageKey('CERTS_BULK_UNKNOWN_ACTION'))
        );
    }
  };

  return (
    <FooterActionBar size='large'>
      <div />
      <div className='BulkActionCommonFooter-footerButtonWrap'>
        <Button
          type='button'
          kind='ghost'
          size='medium'
          isDisabled={bulkActionCommonAction?.isSubmitting}
          onClick={handleCloseBulkActionCommon}>
          {messages['CancelLabel.ATTESTATIONS'] ||
            localize(intl, getMessageKey('CancelLabel'))}
        </Button>
        <Button
          type='button'
          kind={submitBtnKind}
          size='medium'
          onClick={() =>
            handleCommonAction(
              bulkActionCommonAction?.id,
              bulkActionCommonAction?.status,
              bulkActionCommonAction?.comment
            )
          }
          isDisabled={bulkActionCommonAction?.isSubmitting}
          isLoading={bulkActionCommonAction?.isSubmitting}
          loaderText={getActionButtonText(bulkActionCommonAction?.id)}
          className='BulkActionCommonFooter-submitButton'>
          {getActionButtonText(bulkActionCommonAction?.id)}
        </Button>
      </div>
    </FooterActionBar>
  );
}

BulkActionCommonFooter.propTypes = {
  handleCommonAction: PropTypes.func.isRequired,
  bulkActionCommonAction: PropTypes.shape(BULK_ACTION_COMMON).isRequired,
  handleCloseBulkActionCommon: PropTypes.func.isRequired,
};

export default BulkActionCommonFooter;
